/* eslint-disable max-len */
import { useState, useEffect } from 'react';

import getScreenSize from '../helpers/getScreenSize'

export default () => {
  const [screenSize, setScreenSize] = useState(getScreenSize(window.innerWidth, window.innerHeight));

  useEffect(() => {
    const resizeWindow = () => {
      setScreenSize(getScreenSize(window.innerWidth, window.innerHeight));
    };

    window.addEventListener('resize', resizeWindow);

    return () => {
      window.removeEventListener('resize', resizeWindow);
    };
  }, []);

  return screenSize;
};
